import React from 'react';
import { Modal, Button } from 'react-bootstrap';

const FileViewModal = ({ show, onHide, fileUrl,notes }) => {
    console.log(fileUrl,notes)
    const renderContent = () => {
        if (!fileUrl) {
            return <p>No file to display</p>;
        }

        // Extract file extension (handling Firebase URLs)
        const fileExtension = fileUrl.split('?')[0].split('.').pop().toLowerCase();

        if (['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(fileExtension)) {
            return <img src={fileUrl} alt="Proof" className="img-fluid w-100" />;
        } else if (fileExtension === 'pdf') {
            return (
                <embed
                    src={fileUrl}
                    type="application/pdf"
                    width="100%"
                    height="500px"
                />
            );
        } else {
            return (
                <a href={fileUrl} target="_blank" rel="noopener noreferrer">
                    Open File
                </a>
            );
        }
    };

    return (
        <Modal show={show} onHide={onHide} size="md">
            <Modal.Header closeButton>
                <Modal.Title>Proof</Modal.Title>
            </Modal.Header>
            <Modal.Body className="text-center">
                <h4>Admin Notes</h4>

                <p>{notes}</p>
                {renderContent()}</Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default FileViewModal;
